export default {
    data: () => ({
        options: []
    }),
    methods: {
        async optionsGet() {
            const options = this.$communicator.then(
                this,
                await this.$communicator("options_get", {
                    params: {}
                })
            );
            if (options instanceof Array) {
                this.options = options;
            }
            else {
                this.options = []
            }
        }
    }
}
